//!#system	

<template>
	<v-card>
		<v-card-title>
			Reset this password
		</v-card-title>
		<v-divider />
		<v-card-text>
			<v-form ref="passReset" v-model="valid" lazy-validation>
				<v-textarea
					v-model="passwordObj.newPassword"
					append-icon="md-lock" 
					label="New password" 
					clearable
					:rules="passwordRules" 
					:autofocus="true"
					class="mb-4 key"
					rows="1"
					:auto-grow="true"
				/>
			</v-form>
		</v-card-text>
		<v-divider />
		<v-card-actions>
			<v-spacer />
			<v-btn text @click="closeDialog">Exit</v-btn>
			<v-btn color="primary" :disabled="btnDisabled" :loading="isLoading" @click="changePassword">Save</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import series from 'to-series';
import tools from '@/tools.js';
import apiService from '@/apiService.js';
export default {
	props: {
		routeInfo: {
			type: Object
		},
		detail: {
			type: Object
		}
	},
	data() {
		return {
			isLoading: false,
			valid: false,
			passwordObj: {
				newPassword: ''
			},
			passwordRules: [
				v => !!v || 'Password is required',
				v => {
					return v.length < 6 ? 'Password must be greater than 6 characters' : true
				},
				v => {
					// eslint-disable-next-line
					const passwordTest = zxcvbn(v);
					let err = 'Your password needs to be stronger than that.';
					if (passwordTest.feedback && passwordTest.feedback.warning) {
						err = passwordTest.feedback.warning;
					}
					return passwordTest.score <= 2 ? err : true;
				}
			]
		}
	},
	computed: {
		btnDisabled() {
			if (!this.valid) return true;
			if (!this.passwordObj.newPassword) return true;
			return false;
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
		},
		changePassword() {
			if (this.$refs.passReset.validate()) {
				this.isLoading = true;
				apiService.action({
					...this.routeInfo,
					action: 'resetPassword',
					method: 'post',
					payload: {
						newPassword: this.passwordObj.newPassword
					}
				}, (err, response, meta) => {
					this.isLoading = false;
					if (err) {
						return this.$store.dispatch('app/applyObjectError', {
							show: true,
							text: err 
						});
					} else {
						this.$emit('refresh');
						this.closeDialog();
					}
				});
			}
		}
	}
}
</script>